import { render, staticRenderFns } from "./code-select-modal.vue?vue&type=template&id=2dca833c&scoped=true&"
import script from "./code-select-modal.vue?vue&type=script&lang=js&"
export * from "./code-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./code-select-modal.vue?vue&type=style&index=0&id=2dca833c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca833c",
  null
  
)

export default component.exports